export const hasuraAdminSecretHeaderField = 'X-Hasura-Admin-Secret'
export const currencyCookieName = 'currency'
export const currencyParamName = 'currency'
export const abTestConfigCookieName = 'ab-test-config'
export const countryCookieName = 'country'
export const otherCookiesAllowedCookieName = 'otherCookiesAllowed'
export const originCookieName = 'origin'
export const destinationCookieName = 'destination'
export const originParamName = 'origin'
export const destinationParamName = 'destination'
export const countrySpecificParamName = 'countrySpecific'
export const affiliateCookieName = 'affiliate'
export const affiliateParamName = 'affiliate'
export const localeCookieName = 'NEXT_LOCALE'
// Six months: how long the visitor's consent, choices, country and A/B assignment are kept - the
// interval EU guidance points at for asking consent again. Without an expiry a cookie ends with the
// browser session.
export const visitorCookieValidityInDays = 182
// Marks which rules this browser's choice cookies were written under (utils/preferences/choices.ts)
export const choicesVersionCookieName = 'choicesVersion'
